module.exports = __webpack_public_path__ + "static/media/incident_category-infrastructure.977ad9ec.svg";